import React, {createContext, useState} from 'react';
import confirmationModal from "../components/common/ConfirmationModal";
import Notification from "../components/common/Notification";
import WithdrawService from "../services/WithdrawService";

export const WithdrawContext = createContext("WithdrawContext");

const WithdrawContextProvider = ({children}) => {

    const [withdrawList, setWithdrawList] = useState([]);
    const [withdraw, setWithdraw] = useState(null);
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [totalElements, setTotalElements] = useState(0);


    async function getAllWithdraw(params) {
        // async function getAllWithdraw({page, size, id, name, pharmacyOwnerName, pharmacyOwnerPhone}) {

        try {
            setLoading(true);
            const res = await WithdrawService.getAllWithdraw(params);
            // const res = await WithdrawService.getAllWithdraw(page, size, id, name, pharmacyOwnerName, pharmacyOwnerPhone);
            setWithdrawList(res.data.content);
            setTotalElements(res.data.totalElements);
            setLoading(false);
            return res.data.content;
        } catch (error) {
            console.log("error", console.error())
            return false;
        }

    }

    async function getWithdrawById(id) {

        try {
            setLoading(true);
            setErrorMsg('');
            const res = await WithdrawService.getWithdrawById(id);
            setWithdraw(res.data);
            setLoading(false);
            return true;
        } catch (error) {
            setLoading(false);
            setErrorMsg("Can not load Withdraws. Please check the console.");
            console.log("error", error)
            return false;
        }

    }

    async function addWithdraw(data) {

        try {
            setLoading(true);
            setErrorMsg("");
            const res = await WithdrawService.addWithdraw(data);
            Notification("success", "Withdraw create", "Withdraw create successfully");
            setWithdraw(res.data);
            setLoading(false)
            return true;
        } catch (err) {
            setLoading(false);
            const message = err.response ? err.response.data.message : err.message;
            confirmationModal(message, "error");
            return false;
        }
    }

    async function updateWithdraw(data, id) {
        try {
            setLoading(true);
            await WithdrawService.updateWithdraw(data, id)
            setLoading(false);
            // confirmationModal("affiliate updated properly. ", "success");
            Notification("success", "Updated", `affiliate updated properly`);
            return true;
        } catch (error) {
            setLoading(false);
            const message = error.response ? error.response.data.message : error.message
            confirmationModal("Can not update affiliate." + message, "error");
            return false;
        }

    }


    return (
        <WithdrawContext.Provider
            value={{
                withdrawList,
                withdraw,
                totalElements,
                loading,
                getWithdrawById,
                errorMsg,
                getAllWithdraw,
                updateWithdraw,
                addWithdraw,
            }}
        >
            {children}
        </WithdrawContext.Provider>
    );
}

export default WithdrawContextProvider;
